import { render } from "./StatusUnits.vue?vue&type=template&id=20a9619b&scoped=true"
import script from "./StatusUnits.vue?vue&type=script&lang=js"
export * from "./StatusUnits.vue?vue&type=script&lang=js"

import "./StatusUnits.vue?vue&type=style&index=0&id=20a9619b&lang=css"
import "./StatusUnits.vue?vue&type=style&index=1&id=20a9619b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a9619b"]])

export default __exports__